import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-page',
  templateUrl: './common-page.component.html',
  styleUrls: ['./common-page.component.scss'],
})
export class CommonPageComponent implements OnInit {
  constructor() {
    //empty
  }

  ngOnInit(): void {
    //empty
  }
  onBack() {
    window.history.back();
  }
}
